import { AbstractViewModel } from '../../../core/interfaces/abstract-view-model';
import { UserApiModel } from '../../../api/models/user.api-model';
import { MediaObjectViewModel } from '../../../core/models/media-object.view-model';
import { PersonalInformationViewModel } from './personal-information/personal-information-view-model';
import { PersonalInformationApiModel } from '../../../api/models/personal-information.api.model';
import { MediaObjectApiModel } from '../../../api/models/media-object.api-model';
import { FollowApiModel } from '../../../api/models/follow.api-model';
import { ReactionApiModel } from '../../../api/models/reaction.api.model';
import { SocialProfileLinksInterface } from "../../../api/interfaces/social-profile-links.interface";
import { SettingsInterface } from "../../../api/interfaces/settings.interface";

export class UserViewModel extends AbstractViewModel<UserApiModel> {
  public username: string;
  public name: string;
  public email: string | null;
  public currentPassword: string;
  public slug: string | null;
  public info: string | PersonalInformationViewModel;
  public socialProfile: SocialProfileLinksInterface;
  public instagramProfileUrl: string | null;
  public instagramLinkedUsername: string | null;
  public instagramIntegrationStatus: string | null;
  public instagramSyncLimitations: string[] = [];
  public instagramProfileMismatch: boolean = false;
  public settings: SettingsInterface;
  public avatar: MediaObjectViewModel | null;
  public background: MediaObjectViewModel;
  public projects: string[];
  public follows: FollowApiModel[];
  public receivedFollows: FollowApiModel[];
  public reactions: ReactionApiModel[];
  public receivedReactions: ReactionApiModel[];
  public individualProjects: number;
  public collaborationProjects: number;
  public saleProjects: number;
  public soldProjects: number;
  public createdAt: Date;
  public completedAt: Date;
  public lastSeenAt: Date;
  public deleted = false;

  public constructor(protected apiModel: UserApiModel = new UserApiModel()) {
    super(apiModel);
    this.fromApiModel(apiModel);
  }

  public fromApiModel(apiModel: UserApiModel): this {
    this['@id'] = apiModel['@id'];
    this.username = apiModel.username;
    this.name = apiModel.name || apiModel.username;
    this.email = apiModel.email;
    if (apiModel.avatar && typeof apiModel.avatar === 'object') {
      this.avatar = new MediaObjectViewModel(apiModel.avatar as MediaObjectApiModel);
    } else if (typeof apiModel.avatar === 'string') {
      this.avatar = new MediaObjectViewModel();
      this.avatar['@id'] = apiModel.avatar;
    } else {
      this.avatar = null;
    }
    this.info = apiModel.info && typeof apiModel.info === 'object'
      ? new PersonalInformationViewModel(apiModel.info as PersonalInformationApiModel)
      : apiModel.info as string;
    this.socialProfile = apiModel.socialProfile || {} as SocialProfileLinksInterface;
    this.instagramProfileUrl = apiModel.instagramProfileUrl || null;
    this.instagramLinkedUsername = apiModel.instagramLinkedUsername || null;
    this.instagramIntegrationStatus = apiModel.instagramIntegrationStatus || null;
    this.instagramSyncLimitations = apiModel.instagramSyncLimitations || [];
    this.instagramProfileMismatch = !!apiModel.instagramProfileMismatch;
    this.settings = apiModel.settings;
    this.slug = apiModel.slug;
    this.deleted = !!apiModel.deleted;
    this.projects = apiModel.projects;
    this.individualProjects = apiModel.individualProjects;
    this.collaborationProjects = apiModel.collaborationProjects;
    this.saleProjects = apiModel.saleProjects;
    this.soldProjects = apiModel.soldProjects;
    this.createdAt = apiModel.createdAt;
    this.completedAt = apiModel.completedAt;
    this.lastSeenAt = apiModel.updatedAt;
    return this;
  }

  public toApiModel(): UserApiModel {
    this.apiModel.username = this.username;
    this.apiModel.email = this.email;
    this.apiModel.currentPassword = this.currentPassword;
    this.apiModel.slug = this.slug;
    this.apiModel.deleted = this.deleted;
    this.apiModel.socialProfile = this.socialProfile;
    this.apiModel.settings = this.settings;
    return this.apiModel;
  }

  public getApiModel(): UserApiModel {
    return this.apiModel;
  }

  public hasSocialLinks(): boolean {
    return !!(
      this.socialProfile?.facebook ||
      this.socialProfile?.instagram ||
      this.socialProfile?.youtube ||
      this.socialProfile?.instagram
    );
  }
}
